module.exports = __webpack_public_path__ + "img/26.9d20ca95.png";